<template>
  <ScaleControl />
  <ZoomControl />
  <CompassControl v-if="isMapviewShowing" />
  <GeolocationControl v-if="isMapviewShowing" />
  <CustomControls />
</template>

<script>
import { mapGetters } from 'vuex'

import {
  ScaleControl,
  ZoomControl,
  CompassControl,
  GeolocationControl,
  CustomControls
} from '@/components/map/controls'

export default {
  name: 'MapControls',
  components: {
    ScaleControl,
    ZoomControl,
    CompassControl,
    GeolocationControl,
    CustomControls
  },
  computed: {
    ...mapGetters({
      isMapviewShowing: 'isMapviewShowing'
    })
  }
}
</script>
